// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3O4ab","topBottomGutter":"Layout_topBottomGutter__e4xjt"};